export enum Guardtypes {
    Private = 'private',
    Public = 'public',
    Auth = 'auth',
    SetPassword = 'setPassword',
}

export enum RoutePaths {
    Booking = '/booking',
    BookingForm = '/booking-form',
    Login = '/login',
    ForgotPassword = '/forgot-password',
    CompleteLogin = '/complete-login',
    CompleteForgotPassword = '/completeFP',
    NotFound = '/*',
}

export enum AuthKeys {
    accessToken = 'accessToken',
    idToken = 'idToken',
    uDetails = 'uDetails',
}

export enum GuestStatus {
    needsAction = 'needsAction',
    tentative = 'tentative',
    accept = 'accepted',
    declined = 'declined',
}

export const slotOptions = Array(5).fill({ value: 'X', label: 'xx:xx - xx:xx' });
